import { z } from 'zod';

export const emailSchema = z
  .string()
  .min(1, '必須項目です')
  .pipe(z.email('メールアドレスの形式が正しくありません'));

export const passwordSchema = z
  .string()
  .min(1, '必須項目です')
  .min(9, '9文字以上で入力してください')
  .regex(/^(?!\d+$).+$/, '数字のみのパスワードは使用できません')
  .regex(/^(?!.*(password|123456789|qwerty|admin)).*$/i, '一般的なパスワードは使用できません');

export const usernameSchema = z.string().min(1, '必須項目です');

export const passwordConfirmSchema = z.string().min(1, '必須項目です');

/**
 * MFA のコード(認証アプリの6桁またはバックアップコード)
 * 空白・ハイフンの除去や大文字小文字の正規化は API 側で行うため、ここでは必須と長さだけを見る
 */
export const mfaCodeSchema = z.string().trim().min(1, '必須項目です').max(32, 'コードが長すぎます');
